// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SNJv","label":"styles_label__S8Wb-"};